import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";

import { makeStyles } from "@material-ui/core/styles";
import img from "assets/img/bi-gout.png";
import Form from "components/Form/Form";
import Panel from "components/Panel/Panel";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles({
  grid: {
    height: "100vh"
  },
  img: {
    marginBottom: 16,
    marginTop: 16,
    marginLeft: 16
  },
  buttonPrevDesktop: {
    marginTop: 40,
    height: 42,
    borderRadius: 8,
    backgroundColor: "#ffff",
    border: "solid 2px #E85313",
    color: "#E85313",
    fontFamily: "Work Sans",
    fontSize: 14,
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "center"
  },
  buttonNextDesktop: {
    fontFamily: "Work Sans",
    fontSize: 14,
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "center",
    marginTop: 40,
    marginLeft: 26,
    height: 42,
    borderRadius: 8,
    backgroundColor: "#E85313",
    color: "#ffff"
  },
  buttonPrevMobile: {
    marginBottom: 16,
    width: "90%",
    height: 42,
    borderRadius: 8,
    backgroundColor: "#ffff",
    border: "solid 2px #E85313",
    color: "#E85313"
  },
  buttonNextMobile: {
    width: "90%",
    height: 42,
    borderRadius: 8,
    backgroundColor: "#E85313",
    color: "#ffff",
    marginBottom: 15
  }
});

export default function Step3(props) {
  const classes = useStyles();

  return (
    <Grid className={classes.grid} container justify="flex-end">
      <Hidden only={["md", "sm", "lg", "xl"]}>
        <Grid item xs={12} className={classes.img}>
          <img src={img} alt="group" />
        </Grid>
      </Hidden>

      <Grid item xs={12} sm={4} lg={4} xl={3}>
        <Panel step={3} history={props.history} />
      </Grid>

      <Hidden only={"xs"}>
        <Grid item xs={12} sm={8} lg={8} xl={9}>
          <Form
            step={3}
            justify="center"
            buttonPrevDesktop={classes.buttonPrevDesktop}
            buttonNextDesktop={classes.buttonNextDesktop}
          />
        </Grid>
      </Hidden>

      <Hidden only={["sm", "md", "lg", "xl"]}>
        <Grid item xs={12} sm={8} lg={9}>
          <Form
            step={3}
            justify="flex-start"
            buttonPrevMobile={classes.buttonPrevMobile}
            buttonNextMobile={classes.buttonNextMobile}
          />
        </Grid>
      </Hidden>
    </Grid>
  );
}

Step3.propTypes = {
  history: PropTypes.object
};
